import React,{ useEffect } from "react";
import Meta from "./Meta";
import BlogPages from "./BlogPages";
import { useParams } from 'react-router-dom';


    
    // You can use this animeGirlData array to create cards with anime girl images and descriptions in your application.
    
  
function BlogPage() {
      document.title = 'Blogs NSFWartgenerator - Latest Blogs';
      const { slugTitle } = useParams();

  return (
    <>  

 <BlogPages slugTitle={slugTitle}/>

</>
  );
}

export default BlogPage;


